<template>
    <div class="login" style="height:100%;display:flex;align-items:center;">
        <el-button type="primary" size="large" @click="handleClick" v-if="!islogin">登录/注册</el-button>
        <!-- v-if="islogin" -->
        <el-popover v-if="islogin" placement="top-end" :width="150" trigger="click">
            <template #reference>
                <div style="margin-right: 20px;">
                    <el-icon :size="20">
                        <User />
                    </el-icon>
                </div>

            </template>
            <div class="content">
                <div class="item" @click="handleLogout">
                    退出登录
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script lang="ts" setup>
import { ElButton, ElPopover, ElIcon } from 'element-plus'
import { User } from '@element-plus/icons-vue'

const handleClick = () => {
    ; (window as any).openGlobalLogin?.()
}
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn

const handleLogout = () => {
    // @ts-ignore
    Auth.request.requestor({
        url: "/open/jssdk/init/user/logout",
        method: "get",

    }).then(() => {
        userStore.clearAuth()
        window.location.href = '/editor'
    })
}
</script>
<style scoped>
.login {
    position: relative;
}

.content {
    background-color: #fff;
    border-radius: 10px;
}

.item {
    padding: 10px;
    cursor: pointer;
    border-radius: 10px;
    text-align: center;
}

.item:hover {
    background-color: #f5f5f5;
}
</style>
